import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import Box from '@mui/material/Box';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';


const ClassAssembly6C2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/class-assembly/6C/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/class-assembly/6C/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/class-assembly/6C/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/class-assembly/6C/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/class-assembly/6C/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/class-assembly/6C/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/class-assembly/6C/7.webp`;
  
  const photos = [
    
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
}
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      Maha Shivaratri
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
 Class: 6C Date: 2 & 3 February 2026

        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Save Water, Save Life! We are the guardians of nature’s gift.”

<br/>
        </Typography> */}

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
       The students of Class 6C presented their assembly titled ‘Maha Shivaratri’. It was conducted from
Monday, 2 February 2026 to Tuesday, 3 February 2026. The two-days assembly programme was
thoughtfully structured to build understanding and engagement about Festival of Shivaratri. The
first day celebration began with a prayer invoking Lord Shiva. Students explained the importance
of Maha Shivaratri through small introduction, highlighting values such as self-discipline, devotion
and inner peace. The second day, students presented a Dance and a short skit. 
    <br></br>
    The skit depicted
Lord Shiva as the symbol of compassion, cosmic balance and inspiring everyone to follow the
path of truth and self-control. Students also shared thoughts on meditation, fasting and
importance of inner purity on Maha Shivaratri. Creative displays like drawings, posters related to
Lord Shiva were arranged by students, which attracted everyone’s attention.  
    <br></br>  
The Maha Shivaratri celebration concluded with the a prayer, seeking the blessings of Lord Shiva
for wisdom, peace and spiritual strength. By actively participating in the celebration, students
experienced a sense of spiritual connection and culture pride. Overall, Maha Shivaratri
celebration was a soulful and enriching experience, inspiring students of follow the path of
righteousness and carry forward the spiritual values taught by Lord shiva in their daily lives.
        <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Where there is Shiva, there is peace.”
<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <ClassAssemblySidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive2022 />
             </Box>
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default ClassAssembly6C2025